import { MultiSelect, MultiSelectOption } from 'components/forms/multiselect/MultiSelect';
import { MultiSelectPopup } from 'components/forms/multiselect/MultiSelectPopup';
import { useInfiniteLocationsDataSource } from 'custom_hooks/data_hooks/data_source/locationsDataSource';
import { useDrainDataSource } from 'custom_hooks/data_hooks/data_source/useDrainDataSource';
import { useEffect, useMemo } from 'react';

export type LocationsMultiSelectProps = Readonly<{
    corporationId: string;
    /**
     * The location from the context, to be selected by default.
     */
    locationId?: string;
    selectedLocations: MultiSelectOption<string>[];
    onChange: (selections: MultiSelectOption<string>[]) => void;
    /**
     * the trigger class name
     */
    className?: string;
}>;

export function LocationsMultiSelect({
    corporationId,
    locationId,
    selectedLocations,
    onChange,
    className,
}: LocationsMultiSelectProps) {
    const { results: locations } = useDrainDataSource(
        useInfiniteLocationsDataSource({
            name: 'multi-select-locations',
            defaultFilter: { nameSearch: '', corporationId, active: true },
        })
    );

    const multiSelectLocations = useMemo(
        () => locations?.map((l) => ({ title: l.Name, value: l.Id })) ?? [],
        [locations]
    );

    // Default to selecting the location from the context.
    useEffect(() => {
        const initialLocation = multiSelectLocations.find((l) => l.value === locationId);
        if (initialLocation) {
            onChange([initialLocation]);
        }
    }, [multiSelectLocations, locationId, onChange]);

    return (
        <MultiSelectPopup
            label="Locations"
            searchPlaceholder="Filter locations"
            contentClassName="menu-max-height ml-10"
            searchable
            onClear={() => onChange([])}
            filterCount={selectedLocations.length}
            className={className}
        >
            <MultiSelect
                options={multiSelectLocations}
                selectedOptions={selectedLocations}
                onChange={(event) => onChange(event.selected)}
                showSelectAll
            />
        </MultiSelectPopup>
    );
}
